// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'kt-error-dialog',
	templateUrl: './form-error-dialog.component.html'
})
export class FormErrorDialogComponent implements OnInit {
	// Public properties
	viewLoading = false;

	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<DeleteEntityDialogComponent>
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<FormErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { 
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
	}

	close() {
		this.dialogRef.close();
	}

	callBack() {
		this.dialogRef.close({
			proceedAction: true
		});
	}

}
